import $ from "jquery";
import lottie from 'lottie-web';

export default class StageManager {
    constructor() {
        this.step = 1;
        this.content = $('.step-' + this.step);
        this.animationContainer = null;
        this.animation = null;

        //init first box
        $('.box', this.content).addClass('active');

        window.addEventListener('goto', e => {
            this.setContent(e.detail.step);
        });

        $('[data-goto]').click(e => {
            window.dispatchEvent(new CustomEvent('goto', {detail: {step: e.currentTarget.dataset.goto}}));
        })
    }

    setContent(step) {
        console.log('got to step:', step);
        if(step - this.step < 0) {
        $('.box', this.content).removeClass('active');
        } else {
        $('.box', this.content).removeClass('active').addClass('old');
        }
        this.step = step;
        this.content = $('.step-' + this.step);

        console.log(this.step);

        if (this.content.hasClass('animation')) {
            !!this.animation && this.animationContainer.parent().addClass('hide');
            this.animationContainer = $('[data-animation]', this.content);
            this.animationContainer.parent().removeClass('hide');
            this.animation = lottie.loadAnimation({
                container: this.animationContainer[0],
                renderer: 'svg',
                path: this.animationContainer.attr('data-animation'),
                name: 'animation-' + this.step,
                loop: false,
                autoplay: true,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                }
            });
            this.animation.addEventListener('complete', () => {
                this.setContent(parseInt(this.step)+1);
            })
        } else {
            $('.box', this.content).addClass('active').removeClass('old');
        }
    }
}